		 					
				import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class AgreementService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('Agreement');
	}
	
	loadAllForMaster(id: System.Guid): Observable<TooBig4Car.Logic.Agreement[]> {
		return this.myBaseService.loadAll(this.url + '/Master/' + id);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	
}
				
